"use strict";

var _taggedTemplateLiteral = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    flex-direction: column;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CardsFooterWrap = exports.CardsTitleWrap = exports.CardsButton = exports.GridWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Layout = require("../Layout");

var _Button = _interopRequireDefault(require("../Button"));

var GridWrap = (0, _styled.default)(_Layout.Grid)(_templateObject());
exports.GridWrap = GridWrap;
var CardsButton = (0, _styled.default)(_Button.default)({
  textTransform: 'none'
});
exports.CardsButton = CardsButton;
var CardsTitleWrap = (0, _styled.default)(_rebass.Flex)(function (_ref) {
  var space = _ref.theme.space,
      hasSubtitle = _ref.hasSubtitle,
      hasBanner = _ref.hasBanner;
  return {
    marginBottom: hasSubtitle || hasBanner ? space.medium : space.large,
    alignItems: 'center',
    justifyContent: 'space-between'
  };
});
exports.CardsTitleWrap = CardsTitleWrap;
var CardsFooterWrap = (0, _styled.default)(_rebass.Flex)(function (_ref2) {
  var cards = _ref2.theme.cards;
  return {
    justifyContent: 'center',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: '100%',
      width: '100%',
      height: '42rem',
      pointerEvents: 'none',
      backgroundImage: cards.cardGradient
    }
  };
});
exports.CardsFooterWrap = CardsFooterWrap;